<template>
  <div
    class="flex flex-1 h-full flex-col m-0 bg-slate-25 dark:bg-slate-900 style-unset"
  >
    <settings-header
      button-route="new"
      :icon="icon"
      :header-title-class="headerTitleClass"
      :header-title="$t(headerTitle)"
      :button-text="$t(headerButtonText)"
      :show-back-button="showBackButton"
      :back-url="backUrl"
      :show-new-button="showNewButton"
      :show-sidemenu-icon="showSidemenuIcon"
      :disable-new-button-check="disableNewButtonCheck"
      :disable-new-button-tooltip="disableNewButtonTooltip"
    />
    <div class="flex-1 min-h-0 flex flex-col overflow-hidden">
      <div class="settings-view-port flex-1 min-h-0 flex flex-col overflow-hidden">
        <keep-alive v-if="keepAlive">
          <router-view :key="routerViewKey" />
        </keep-alive>
        <router-view v-else :key="routerViewKey" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: 0 */
import SettingsHeader from './SettingsHeader';

export default {
  components: {
    SettingsHeader,
  },
  props: {
    headerTitle: { type: String, default: '' },
    headerTitleClass: { type: String, default: '' },
    headerButtonText: { type: String, default: '' },
    icon: { type: String, default: '' },
    keepAlive: {
      type: Boolean,
      default: true,
    },
    newButtonRoutes: {
      type: Array,
      default: () => [],
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    showSidemenuIcon: {
      type: Boolean,
      default: true,
    },
    disableNewButtonCheck: {
      type: String,
      default: '',
    },
    disableNewButtonTooltip: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    currentPage() {
      return this.$store.state.route.name;
    },
    showNewButton() {
      return this.newButtonRoutes.length !== 0 && !this.showBackButton;
    },
    routerViewKey() {
      const { name, params } = this.$route || {};
      const id = params && params.campaigns_id;
      return id ? `${name}-${id}` : name || this.$route.fullPath;
    },
  },
};
</script>
<style scoped>
.style-unset {
  justify-content: unset;
}

.settings-view-port {
  position: relative;
}
</style>
